import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, PillIcon, AlertTriangleIcon, FootprintsIcon, MoonIcon } from 'lucide-react';
const problems = [{
  icon: <FlameIcon className="w-7 h-7 text-danger" data-id="element-116" />,
  text: 'Son las 2 AM y sientes miles de alfileres calientes atravesando tus pies...'
}, {
  icon: <PillIcon className="w-7 h-7 text-danger" data-id="element-117" />,
  text: 'Tu doctor te recetó Gabapentina y te dijo "controla tu azúcar"... y nada más.'
}, {
  icon: <AlertTriangleIcon className="w-7 h-7 text-danger" data-id="element-118" />,
  text: 'Viste una mancha roja en tu pie y el miedo a la palabra "amputación" te paralizó.'
}, {
  icon: <FootprintsIcon className="w-7 h-7 text-danger" data-id="element-119" />,
  text: 'Las cremas de farmacia solo huelen a mentol pero el ardor profundo sigue ahí.'
}, {
  icon: <MoonIcon className="w-7 h-7 text-danger" data-id="element-120" />,
  text: 'Sacas los pies de las cobijas buscando alivio, pero el dolor punzante no para.'
}];
export function ProblemSection() {
  return <section className="py-20 lg:py-28 bg-cream" data-id="element-121">
      <div className="max-w-4xl mx-auto px-5 sm:px-8" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-123">
          <h2 className="text-4xl sm:text-5xl font-heading font-bold text-charcoal mb-4" data-id="element-124">
            ¿Te Suena Familiar?
          </h2>
          <div className="w-20 h-1 bg-gold-brand mx-auto rounded-full" data-id="element-125" />
        </motion.div>

        <div className="space-y-5" data-id="element-126">
          {problems.map((p, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-white p-6 sm:p-8 rounded-xl shadow-sm border-l-4 border-danger/70 flex items-start gap-5" data-id="element-127">
              <div className="flex-shrink-0 bg-red-50 p-3 rounded-full" data-id="element-128">
                {p.icon}
              </div>
              <p className="text-lg sm:text-xl font-body text-charcoal leading-relaxed" data-id="element-129">
                {p.text}
              </p>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-14 text-center text-2xl sm:text-3xl font-heading font-semibold text-emerald-brand italic leading-snug" data-id="element-130">
          No es tu culpa. El sistema de salud te falló.
          <br data-id="element-131" />
          <span className="text-gold-brand not-italic" data-id="element-132">
            Pero hoy eso cambia.
          </span>
        </motion.p>
      </div>
    </section>;
}